import { QuotationSummaryResponse } from 'data-layer-cr/dist/models';

function validateRole(quotationSummary: QuotationSummaryResponse): boolean {
  const { quotationSequence, userRole, username } = quotationSummary;
  return (
    ![0, null, undefined].includes(quotationSequence) &&
    !['', null, undefined].includes(userRole) &&
    !['', null, undefined].includes(username)
  );
}

export default validateRole;
